webpackJsonp([1],{

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_api_account_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_auth__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(34);

//
//
//
//
//

// 2.0兼容IE






var FALLTHROUGH_PATHS_PATTERN = /\/(reset|password|login).*/i;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['loggingStatus', 'testPlatform', 'checkIP']), {
    getCookies: function getCookies() {
      var currentPath = this.$router.currentRoute.path;
      if (!FALLTHROUGH_PATHS_PATTERN.test(currentPath)) {
        var userEmail = __WEBPACK_IMPORTED_MODULE_3__utils_auth__["a" /* default */].getCookie('userEmail');
        var nextHop = void 0;
        if (userEmail) {
          nextHop = userEmail === 'facebook' ? '/login#facebook' : '/login';
        } else {
          nextHop = '/signup';
        }
        this.$router.push(nextHop);
      } else {
        // do nothing to fallthrough
      }
    },
    checkUrl: function checkUrl() {
      if (!location.href.includes('direct')) {
        this.getCookies();
      }
    },
    preventDefaults: function preventDefaults() {
      document.addEventListener('mousemove', function (e) {
        e.preventDefault();
      }, false);
    }
  }),
  mounted: function mounted() {
    this.testPlatform();
    this.checkIP();
    __WEBPACK_IMPORTED_MODULE_2__src_api_account_js__["a" /* default */].getToken({ version: Math.random() });
    this.checkUrl();
    this.loggingStatus();
    this.preventDefaults();
  }
});

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tips',
  data: function data() {
    return {
      popShow: false,
      popText: ''
    };
  },

  methods: {
    popTips: function popTips(tips) {
      var components = this;
      this.popShow = true;
      this.popText = tips;
      setTimeout(function () {
        components.popShow = false;
      }, 3000);
    }
  }
});

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(34);
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bannerBg',
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapState */])(['platform']),

  data: function data() {
    return {
      bannerPic: this.platform === 'LegendHill'
    };
  }
});

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "fbDeprecatedModal",
  data: function data() {
    return {
      popShow: false
    };
  },

  methods: {
    show: function show() {
      this.popShow = true;
    },
    hide: function hide() {
      this.popShow = false;
    }
  }
});

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'topTitles',
  props: ['currentPage'],
  data: function data() {
    return {
      topTitles: true,
      titles: '',
      titlesCon: ''
    };
  },
  mounted: function mounted() {
    if (this.$store.state.platform === 'LegendHill' || this.$store.state.platform === 'Facebook') {
      this.titles = 'PLAY FREE POKER';
      this.titlesCon = 'While listening to your favorite music';
    } else {
      if (this.currentPage === 'loginText') {
        this.titles = 'WELCOME BACK';
        this.titlesCon = 'Login with Your PokerAllDay Account';
      } else {
        this.titles = 'PLAY FREE POKER';
        this.titlesCon = 'With PokerAllDay By CaptivePlay';
      }
    }
  }
});

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_account_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_auth_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_trackers_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Alert_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectActive: [{
        active: false,
        src: 'static/images/woman-d1f69e9da2.png'
      }, {
        active: true,
        src: 'static/images/man-931e9676ea.png'
      }],
      sex: 1,
      avatarCode: 1001
    };
  },


  components: { Alert: __WEBPACK_IMPORTED_MODULE_4__components_Alert_vue__["a" /* default */] },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(['platform']),
  methods: {
    selectAvatar: function selectAvatar(item, index) {
      this.selectActive.forEach(function (val) {
        val.active = false;
      });
      item.active = true;
      if (index === 1) {
        this.sex = 1;
        this.avatarCode = 1001;
      } else {
        this.sex = 2;
        this.avatarCode = 2001;
      }
    },
    playNow: function playNow() {
      var _this = this;

      var data = {
        version: Math.random(),
        sex: this.sex,
        avatarCode: this.avatarCode
      };

      var base = location.href.includes('staging') ? 'https://staging-games.' + window.location.host.split('.')[1] + '.com/' : 'https://games.' + window.location.host.split('.')[1] + '.com/';

      var path = {
        'Web': 'poker/#getBonus?' + __WEBPACK_IMPORTED_MODULE_1__utils_auth_js__["a" /* default */].getCookie('rewardUrl'),
        'LegendHill': 'poker/#getBonus',
        'Facebook': 'poker/index_facebook.html#getBonus'
      };

      __WEBPACK_IMPORTED_MODULE_0__api_account_js__["a" /* default */].bindAvatar(data).then(function (res) {
        if (res.data.State === 1) {

          try {
            var evt = 'choose_avatar';
            var params = {
              "result": res.data.State === 1
            };
            console.log('ReportEvent', evt, params);
            gtag('event', evt, params);
          } catch (err) {
            console.error('ReportEventFailed', err);
          }

          var redirectUrl = __WEBPACK_IMPORTED_MODULE_5_qs___default.a.parse(window.location.search, { ignoreQueryPrefix: true }).r;

          if (redirectUrl) {
            window.location.href = redirectUrl;
          } else {
            window.location.href = base + path[_this.platform];
          }

          __WEBPACK_IMPORTED_MODULE_3__utils_trackers_js__["a" /* default */].avatarStatistics(_this.platform, 'gender_male_click', 'avatar_male_click', _this.sex);
        } else {}
      });
    }
  }
});

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_account_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_validate_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_trackers_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Alert_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FBDeprecatedModal_vue__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(90);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      currentLogin: 'loginText',
      facebook: true,
      emailLogin: false,
      isValidEmail: false,
      stateBtn: false,
      failedLoginAttempts: 0,
      showLogin: true,
      ctrlCount: 0

    };
  },


  components: { Alert: __WEBPACK_IMPORTED_MODULE_6__components_Alert_vue__["a" /* default */], FBDeprecatedModal: __WEBPACK_IMPORTED_MODULE_7__components_FBDeprecatedModal_vue__["a" /* default */] },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['platform']),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['loggingStatus', 'faceBookLogin', 'googleLogin', 'yahooLogin']), {
    switchEmail: function switchEmail() {
      this.facebook = false;
      this.emailLogin = true;
      this.stateBtn = true;
    },
    switchFacebook: function switchFacebook() {
      this.facebook = true;
      this.emailLogin = false;
      this.stateBtn = false;
    },
    emailCheck: function emailCheck() {
      var _this = this;

      this.isValidEmail = __WEBPACK_IMPORTED_MODULE_4__utils_validate_js__["a" /* default */].email(this.email.trim(), function (res) {
        _this.$refs.tips.popTips(res);
      });
    },
    passwordCheck: function passwordCheck() {
      if (!this.password) {
        this.$refs.tips.popTips('Please enter your password');
      }
    },
    handleFacebookLogin: function handleFacebookLogin() {
      this.$refs.fbDeprecatedModal.show();
    },
    handleYahooLogin: function handleYahooLogin() {
      this.yahooLogin();
    },
    handleEmailLogin: function handleEmailLogin() {
      var _this2 = this;

      this.emailCheck();
      if (this.isValidEmail) {
        if (!this.password) {
          this.$refs.tips.popTips('Please enter your password');
        } else {
          __WEBPACK_IMPORTED_MODULE_5__utils_trackers_js__["a" /* default */].statisticsLogin(this.platform, 'login_click', 'login_click');
          var data = {
            version: Math.random(),
            email: this.email,
            pwd: __WEBPACK_IMPORTED_MODULE_2__utils_auth_js__["a" /* default */].rsa(this.password)
          };
          __WEBPACK_IMPORTED_MODULE_3__api_account_js__["a" /* default */].login(data).then(function (res) {
            if (res.data.State === 1) {
              _this2.loggingStatus();
              __WEBPACK_IMPORTED_MODULE_2__utils_auth_js__["a" /* default */].setCookie('userEmail', _this2.email, 30);
              __WEBPACK_IMPORTED_MODULE_5__utils_trackers_js__["a" /* default */].loginSucceed(_this2.platform);
            } else {
              _this2.$refs.tips.popTips(res.data.Message);
              __WEBPACK_IMPORTED_MODULE_5__utils_trackers_js__["a" /* default */].loginFailed(_this2.platform, res.data.Message);
              if (_this2.failedLoginAttempts >= 0) {
                _this2.failedLoginAttempts += 1;
                if (_this2.failedLoginAttempts >= 3) {
                  var isRedirect = confirm("You've entered the wrong password too many times, click OK to reset your password.");
                  _this2.failedLoginAttempts = isRedirect ? 0 : -1;
                  if (isRedirect) {
                    __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push({ path: '/password' });
                  }
                }
              }
            }
          });
        }
      }
    },
    handleGoogleLogin: function handleGoogleLogin() {
      this.googleLogin();
    },
    getUrlParam: function getUrlParam() {
      var _this3 = this;

      if (!location.href.includes('direct')) {
        var emails = __WEBPACK_IMPORTED_MODULE_2__utils_auth_js__["a" /* default */].getCookie('userEmail');
        // a workaround for nonstructural routing ¯\_(ツ)_/¯
        if (decodeURIComponent(location.hash).indexOf('#email') > 0) {
          this.switchEmail();
        }
        if (emails && emails != "facebook") {
          this.switchEmail();
          this.$nextTick(function () {
            _this3.email = emails;
          });
        }
      } else {
        if (location.href.includes('email')) {
          this.switchEmail();
          this.email = __WEBPACK_IMPORTED_MODULE_4__utils_validate_js__["a" /* default */].getQuery();
        }
      }
    }
  }),
  created: function created() {
    var component = this;
    window.onkeydown = function (e) {
      if (location.href.includes('login') && !location.href.includes('facebook')) {
        if (e.which === 13 || e.keyCode === 13) {
          component.handleEmailLogin();
        }

        // if(e.ctrlKey&&e.keyCode===65){
        //   component.showThirdpartLogin();
        // }
      }
    };
  },
  mounted: function mounted() {
    this.getUrlParam();
    __WEBPACK_IMPORTED_MODULE_5__utils_trackers_js__["a" /* default */].statisticsLogin(this.platform, 'login_view', 'view');
  }
});

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_account_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_validate_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Alert_vue__ = __webpack_require__(60);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      isValidEmail: false
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(['platform']),

  components: { Alert: __WEBPACK_IMPORTED_MODULE_3__components_Alert_vue__["a" /* default */] },
  methods: {
    emailCheck: function emailCheck() {
      var _this = this;

      this.isValidEmail = __WEBPACK_IMPORTED_MODULE_1__utils_validate_js__["a" /* default */].email(this.email.trim(), function (res) {
        _this.$refs.tips.popTips(res);
      });
    },
    reset: function reset() {
      var _this2 = this;

      this.emailCheck();

      if (this.isValidEmail) {
        var data = {
          version: Math.random(),
          email: this.$refs.email.value,
          isH5: true
        };

        __WEBPACK_IMPORTED_MODULE_0__api_account_js__["a" /* default */].forgetPassword(data).then(function (res) {
          if (res.data.State === 1) {
            _this2.$refs.tips.popTips('We\'ve sent a link to reset your password. Please check your inbox . The link will expire in one hour.');
          } else {
            _this2.$refs.tips.popTips(res.data.Message);
          }
        });
      }
    }
  }
});

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auth_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_account_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Alert_vue__ = __webpack_require__(60);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      password1: '',
      password2: '',
      isInvalidPassword: false,
      confirmed: false,
      pending: false
    };
  },

  components: { Alert: __WEBPACK_IMPORTED_MODULE_4__components_Alert_vue__["a" /* default */] },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['platform']),
  methods: {
    password1Check: function password1Check() {
      var _this = this;

      this.isInvalidPassword = __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__["a" /* default */].password(this.password1, function (res) {
        _this.$refs.tips.popTips(res);
      });
    },
    password2Check: function password2Check() {
      if (this.isInvalidPassword) {
        if (this.password1 === this.password2) {
          this.confirmed = true;
        } else {
          this.$refs.tips.popTips('The password does not match. Please input again.');
        }
      }
    },
    reset: function reset() {
      var _this2 = this;

      this.password1Check();
      this.password2Check();

      if (this.pending) {
        this.$refs.tips.popTips('Submitted. Please wait');
      }

      if (this.isInvalidPassword && this.confirmed) {
        var data = {
          version: Math.random(),
          pwd: __WEBPACK_IMPORTED_MODULE_0__utils_auth_js__["a" /* default */].rsa(this.password1),
          pwd2: __WEBPACK_IMPORTED_MODULE_0__utils_auth_js__["a" /* default */].rsa(this.password2)
        };

        this.pending = true;

        __WEBPACK_IMPORTED_MODULE_1__api_account_js__["a" /* default */].resetPassword(data).then(function (res) {
          if (res.data.State === 1) {
            _this2.$refs.tips.popTips(res.data.Message);
            setTimeout(function () {
              if (location.href.indexOf('staging') !== -1) {
                window.location.href = 'https://staging-games.' + window.location.host.split('.')[1] + '.com/poker/';
              } else {
                window.location.href = 'https://games.' + window.location.host.split('.')[1] + '.com/poker/';
              }
            }, 3000);
          } else {
            _this2.$refs.tips.popTips(res.data.Message);
            _this2.pending = false;
          }
        }).catch(this.pending = false);
      }
    }
  }
});

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_account_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_auth_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_trackers_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Alert_vue__ = __webpack_require__(60);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      currentLogin: 'signupText',
      isFromEU: false,
      checked: false,
      facebook: true,
      emailLogin: false,
      isValidEmail: false,
      isValidPassword: false,
      stateBtn: false,
      currentDomain: window.location.host.split('.')[1] + '.com'
    };
  },

  components: { Alert: __WEBPACK_IMPORTED_MODULE_6__components_Alert_vue__["a" /* default */] },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['platform', 'userLocationCode', 'accountConfirmed']),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['loggingStatus', 'faceBookLogin', 'googleLogin', 'yahooLogin']), {
    handleGoogleLogin: function handleGoogleLogin() {
      this.googleLogin();
    },
    handleYahooLogin: function handleYahooLogin() {
      this.yahooLogin();
    },
    switchEmail: function switchEmail() {
      this.facebook = false;
      this.emailLogin = true;
      this.stateBtn = true;
      this.isFromEU = this.userLocationCode === 1;
    },
    switchFacebook: function switchFacebook() {
      this.facebook = true;
      this.emailLogin = false;
      this.stateBtn = false;
    },
    emailCheck: function emailCheck() {
      var _this = this;

      this.isValidEmail = __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__["a" /* default */].email(this.email.trim(), function (res) {
        _this.$refs.tips.popTips(res);
      });
    },
    passwordCheck: function passwordCheck() {
      var _this2 = this;

      if (this.isValidEmail) {
        this.isValidPassword = __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__["a" /* default */].password(this.password.trim(), function (res) {
          _this2.$refs.tips.popTips(res);
        });
      }
    },
    getUrlParam: function getUrlParam() {
      if (location.href.includes('direct') && location.href.includes('email')) {
        this.switchEmail();
        this.email = __WEBPACK_IMPORTED_MODULE_2__utils_validate_js__["a" /* default */].getQuery();
      }
    },
    handleEmailSignUp: function handleEmailSignUp() {
      var _this3 = this;

      this.emailCheck();
      this.passwordCheck();

      if (this.isValidEmail && this.isValidPassword) {
        var data = {
          version: Math.random(),
          email: this.email,
          pwd: __WEBPACK_IMPORTED_MODULE_4__utils_auth_js__["a" /* default */].rsa(this.password),
          email_promotion_allowed: !this.isFromEU || this.isFromEU && this.checked
        };
        __WEBPACK_IMPORTED_MODULE_1__api_account_js__["a" /* default */].singUp(data).then(function (res) {
          if (res.data.Value && res.data.State === 1) {
            _this3.accountConfirmed = true;
            _this3.loggingStatus();
            __WEBPACK_IMPORTED_MODULE_4__utils_auth_js__["a" /* default */].setCookie('userEmail', _this3.email, 30);
            __WEBPACK_IMPORTED_MODULE_5__utils_trackers_js__["a" /* default */].signSucceed(_this3.platform);
          } else {
            _this3.$refs.tips.popTips(res.data.Message);
            __WEBPACK_IMPORTED_MODULE_5__utils_trackers_js__["a" /* default */].signFailed();
          }

          try {
            var evt = 'sign_up';
            var params = {
              "result": res.data.Value && res.data.State === 1
            };
            console.log('ReportEvent', evt, params);
            gtag('event', evt, params);
          } catch (err) {
            console.error('ReportEventFailed', err);
          }
        });
        __WEBPACK_IMPORTED_MODULE_5__utils_trackers_js__["a" /* default */].statisticsSign('signup_click', 'signup_click');
      }
    }
  }),

  mounted: function mounted() {
    this.getUrlParam();
    __WEBPACK_IMPORTED_MODULE_5__utils_trackers_js__["a" /* default */].statisticsSign('signup_view', 'view');
  }
});

/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_validate_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_account_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_trackers__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Alert_vue__ = __webpack_require__(60);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      username: '',
      emailState: false
    };
  },


  components: {
    Alert: __WEBPACK_IMPORTED_MODULE_5__components_Alert_vue__["a" /* default */]
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapState */])(['platform', 'usernameConfirmed']),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['loggingStatus']), {
    next: function next() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_1__utils_validate_js__["a" /* default */].username(this.username, function (res) {
        _this.$refs.tips.popTips(res);
      })) {
        var data = {
          version: Math.random(),
          roleName: this.username,
          isH5: true
        };
        __WEBPACK_IMPORTED_MODULE_2__api_account_js__["a" /* default */].bindLzRoleName(data).then(function (res) {
          if (res) {
            if (res.data.State === 1) {
              _this.usernameConfirmed = true;
              _this.loggingStatus();
              __WEBPACK_IMPORTED_MODULE_3__utils_trackers__["a" /* default */].selectUsernameSucceed(_this.platform);
            } else if (res.data.State === -101 && res.data.Value) {
              _this.username = res.data.Value;
              _this.$refs.tips.popTips(res.data.Message);
            } else {
              _this.$refs.tips.popTips(res.data.Message);
              __WEBPACK_IMPORTED_MODULE_3__utils_trackers__["a" /* default */].selectUsernameFailed(_this.platform, res.data.Message);
            }

            try {
              var evt = 'create_username';
              var params = {
                "result": res.data.State === 1
              };
              console.log('ReportEvent', evt, params);
              gtag('event', evt, params);
            } catch (err) {
              console.error('ReportEventFailed', err);
            }
          }
        });
      }
    }
  })
});

/***/ }),

/***/ 202:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFkAAABSCAYAAAA/zHhsAAAACXBIWXMAAAsTAAALEwEAmpwYAAADZklEQVR4nO2cTW7UQBCF34QgEbHJggVCILGPcgfOQi6QLafgBmzhLCwRYh/xJySisEBBiEyGxeDgybjH3V2vymW7PilS4niq28/P1eXuThar1QrBFixRTgC8WoTIWzAFWQDAHjFgkCBE3oTp4uPmm0gXm9BTBRBObvOLGGvZ/iGc/B8VFwPhZBNC5DVqLgZCZBNCZOAPMday62AMfMqpAggnmzB3kdVdDITIJsxZ5C/EWNe7fjnngc8kVQDzdfJzYqyrvhPm6mQzFwPTc/Kzf1+u2AfnrvbezUI0+2TqYoDn5FnmnFz2wHehZzrnFirpHfAamDn5BSmOZqpgXu/d3BPb1YWX3KzVj5cATgmxd7XRibfq4oIQ4zhx/JQQu+FdycltJy/BEV3i5klVFQ1tUe8QO+EN5oBXPMl/+42PcbevUXfDJuliYDs9MAYub3n+09Ad6Jq7GKLK+AngvlKbg7oY6HbdZ2FHgPILkwrsmi6RHxv34SMhxtvE8cFdDKSnOhmdOwPwNOO8yQ54Nx/cMZ9slZu12rkAcEiIDaznKbJfo28zdCVwRoiRupGHhNgN1QID/Ssj2m6efKoAhneylPPEcabA4jq7T+TUqM2AIcQDQow+nkgD5Cykaj3SnuP2tVFETrpgTq40MHZSWqzoUNrI3RIgdcdvAPeI8YARLZtZiQxsiiKNNxqBgfzqgnlRs1vZtizhWOJqVjwqlGzTuoKP1RPpq/pXAI9IfcmidC+ch0c9JfIlgANSLCr7Fo0QYb9Cr3bEpFGakz2O6tKnS/3pHNPchccbnEWNyJ4uluVCVTePycmjpVbk7B2NJCwmgtTcXCuyaKVgbowhXXgaA6qQiDz6i7fCu5O/Dd0BBlKRP1B6keahcnwTpCIfUXrhg9TmcTGe00Vfzn9Dbu89Od4NrL9I1agxrXYfAetNlmp7AL2KfI785X7364WsdMHOZxb7KRrUS1HmH7APuS2qtm2TWp858LH2Z9Rc+KLwc98r26mC/a8YvOTHVD8GeUtlLj95EZgZh4LnOnkysET+QYihsefOBZ7qZFePOJNIFwYwRA4X9xBONkAqMmOwuiTEcI104ItUkYHEya9pvZg4EieHizOJgc+AWpEZLj4hxBgFtekiUkUBNU5mCDz5sq1NjZPDxYX8BXFXz8XG2qruAAAAAElFTkSuQmCC"

/***/ }),

/***/ 203:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABHhJREFUaAXtWV1oHFUU/mZmNz9ks01d240laQylK4UoRYsVjLU/FEQQRF9snwr9EwqiRagUlBap1qII4ov4olAffGglNg+togjGF7VQbCCQJrRpmjRNSLLJJs3sZHbWc6Y723tntnazM8uusAfO3nvuvXPO991zZ+beWaAmlZ0BxRXesZ3S1V1xM5tD4JQICZAYNKuWU8cWhlSsyoBZMzllIHkSbLAw4PDo6OjrmUxmLFtlwpgI22uMMYeVinug7Qr9qKQNNPCaqqrrnMZqKi3LGtc0bSNh0kktxsaz7ggvnWaa+FmnoRpLRVFWE64UKS8ne9a5ZGEy9Xatun8YY37iedk4wo3iTe20V1vJGAsSYKD5jmpDLeCRMIoZEMb8f6o1ApXOVS0Dlc5A4I9Nc3AA+oXzMK8PITN+C9llA1psDcJPbkb99t0IP7M1UM7iI4n3GHF6E4+WEsGavIPUmZMwrvz9n5czkeixE1BbS9ut0Ju4nQLcIV3mQIHcA+ZAP2aP7HsoeA64fPUKUp9/zNVAxPcSsqanMHf8bVipeQlQqL0DoQ0JZC0L5vAgaC9p94cTmxB9/yNprB/DN4HUmRMSeG1tHJG3jqHuuW4Jl9H3G/SLP6L5vZNQIs1Snx/DH4HkHwi3noehtdHeUIH26Bq0fPYV1Me867uueztYgxZfBKyJs6h7ahpa/C4WfuhE0/4jBcEHDVr054tAdu5P25cWX8Kqg1MI7XpJ9G3XT18wPG1iQ3dCQ/cTfBQpTXwRgH4zH1WJJeiZ5n2o/XzVftrlx7krEdrd+yHgjeiOUGbbMP0F8JWBbD29U8w5G4G+eB2NWQuqIs9Je0y2l+kgOJG0j7P2dS1N4rt05WT8EYhugbLYj0FzFY7PbsKhkd/x8uMvSii+Odwo2T2XTXxxKZ1vW+8imO8osiJPT5EXOcOs+B706utxMPkCxjJN+PKf7zC2OOl0e8r5JeDcX/fvCVVR8OyG0m9gDuCLQH1sB36J0BYi52ZqaQZv/voB+m5f9oAfTN7AO9+PYGzm/vLZ1aUhKifIc93DGsQFWNJmjkG/cfEo5o0FKVZH8zokVndCo3tiJDWOgZlhqFYjGiYPIbT4NCINCr4+0Ii1URGC5KKg4d7MiVeXRICj9E9fw7t9n2BaTxYM6m5sNV7Fh9v2YnPHyheAm8DKPbjRkN0V24hvd5/GlnhXgV65qTPahk9feb4k8LKne1YgGRAdD8wO49zQTxiau4lbCxNIZwzEGlqIZAI727ZiB6ni4+uNOwOBExDJlKPuJhDIEioH0GJ91ggUO1PlGlfLQLlmtli/tQwUO1PlGufOgOefv3IF9uFXwughkE6nH7wf9hE1iEtz2B5IgDvM3t7eU7quTwURMEgfjKmnp+cUYyTNkxC3EnyyiJC2kj5CWkfqzhA1VUT4EMGfN2ZIJ0h5727/SykeKZkVn/X4b1burEYC/P2SMRbMAGeDZ5zPBQyeyYkZIrNiYi9vis5Z4DMpZ8Qm4QbItqhkVo0wYFFtYP8C8gLVfzBSHJgAAAAASUVORK5CYII="

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(229);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */]
}));

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(141);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e85d629_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(24);
function injectStyle (context) {
  __webpack_require__(484)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e85d629_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e85d629_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Banner_vue__ = __webpack_require__(143);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c598dd4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banner_vue__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(24);
function injectStyle (context) {
  __webpack_require__(476)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c598dd4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Banner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c598dd4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banner_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c598dd4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banner_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Titles_vue__ = __webpack_require__(145);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14499c2f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Titles_vue__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(24);
function injectStyle (context) {
  __webpack_require__(474)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14499c2f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Titles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14499c2f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Titles_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14499c2f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Titles_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Banner_vue__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Titles_vue__ = __webpack_require__(207);




// 2.0兼容IE, axios在ie中沒有promise对象?




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('banner', __WEBPACK_IMPORTED_MODULE_5__components_Banner_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('titles', __WEBPACK_IMPORTED_MODULE_6__components_Titles_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable */

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__vuex__["a" /* default */],
  render: function render(createElement) {
    var _this = this;

    if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
      window.addEventListener('hashchange', function () {
        var currentPath = window.location.hash.slice(1);
        if (_this.$route.path !== currentPath) {
          app;
          _this.$router.push(currentPath);
        }
      }, false);
    }
    return createElement(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);





// 旧的用于请求C#服务器
var oldService = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({

  baseURL: location.href.includes('staging') ? location.protocol + '//staging-napi.' + window.location.host.split('.')[1] + '.com/' : location.protocol + '//napi.' + window.location.host.split('.')[1] + '.com/',
  withCredentials: true

});

oldService.interceptors.request.use(function (config) {
  if (config.method === 'post') {
    config.data = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(config.data);
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  }
  return config;
}, function (error) {
  console.log('err' + error); // for debug
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// 新 的用于请求Java服务器
var service = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({

  baseURL: location.href.includes('staging') ? location.protocol + '//staging-api.' + window.location.host.split('.')[1] + '.com/' : location.protocol + '//api.' + window.location.host.split('.')[1] + '.com/',
  withCredentials: true

});

service.interceptors.request.use(function (config) {
  if (config.method === 'post') {
    config.data = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(config.data);
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  }
  return config;
}, function (error) {
  console.log('err' + error); // for debug
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = ({
  service: service,
  oldService: oldService
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_account_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_auth_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(90);





/* harmony default export */ __webpack_exports__["a"] = ({
  checkIP: function checkIP(state) {
    __WEBPACK_IMPORTED_MODULE_0__api_account_js__["a" /* default */].getUserLocation().then(function (res) {
      if (res.data.State === 1) {
        state.userLocationCode = res.data.Value;
      }
    });
  },
  testPlatform: function testPlatform(state) {
    if (window.top === window.self) {
      state.platform = 'Web';
    } else if (window.top !== window.self && location.href.includes('cumulus')) {
      state.platform = 'LegendHill';
    } else {
      state.platform = 'Facebook';
    }
  },
  loggingStatus: function loggingStatus(state) {
    __WEBPACK_IMPORTED_MODULE_0__api_account_js__["a" /* default */].getLoginUserInfo({
      version: Math.random()
    }).then(function (res) {
      var base = location.href.includes('staging') ? 'https://staging-games.' + window.location.host.split('.')[1] + '.com/' : 'https://games.' + window.location.host.split('.')[1] + '.com/';

      if (res.data.State === 1 && res.data.Value.IsLogined) {
        if (!location.href.includes('reset')) {
          if (!res.data.Value.IsBindLz) {
            __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: '/username' });
          } else if (!res.data.Value.IsBindAvatar) {
            __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: '/avatar' });
          } else {
            var redirectTo = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.parse(window.location.search, { ignoreQueryPrefix: true }).r;

            state.isLogin = true;
            if (redirectTo) {
              window.location.href = redirectTo;
            } else {
              var IEVersion = IE();
              if (IEVersion && IEVersion <= 9) {
                window.location.href = base + 'poker-flash'; // ie低版本跳转flash版本poker
              } else {
                if (__WEBPACK_IMPORTED_MODULE_1__utils_auth_js__["a" /* default */].getCookie('rewardUrl')) {
                  window.location.href = base + 'poker/?' + __WEBPACK_IMPORTED_MODULE_1__utils_auth_js__["a" /* default */].getCookie('rewardUrl');
                } else {
                  window.location.href = base + 'poker';
                }
              }
            }
          }
        }
      }
    });
  },
  faceBookLogin: function faceBookLogin(state) {
    console.log("faceBookLogin");
    FB.login(function (response) {
      if (response.authResponse) {
        if (response.status === 'connected') {
          var userId = response.authResponse.userID;
          var accessToken = response.authResponse.accessToken;
          var platformNum = 0;
          if (accessToken) {
            var baseURL = location.href.includes('staging') ? location.protocol + '//staging-napi.' + window.location.host.split('.')[1] + '.com/' : location.protocol + '//napi.' + window.location.host.split('.')[1] + '.com/';
            var params = {
              accessToken: accessToken,
              userid: userId,
              expiresIn: response.authResponse.expiresIn,
              platform: platformNum
            };
            // referrer
            var r = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.parse(window.location.search, { ignoreQueryPrefix: true }).r;
            if (r) {
              params.r = r;
            }
            __WEBPACK_IMPORTED_MODULE_1__utils_auth_js__["a" /* default */].setCookie('userEmail', 'facebook', 30);
            window.location.href = baseURL + 'webapi/page/facebooklogin/FacebookDialogLogin?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(params);
          }
        }
      } else {
        console.log('User cancelled login or did not fully authorize.');
      }
    }, {
      scope: 'email'
    });
  },
  googleLogin: function googleLogin(state) {
    console.log("googleLogin");
    if (window.googleClient == null) {
      window.googleClient = google.accounts.oauth2.initTokenClient({
        client_id: '14460564560-l6ld63amkl8lfo2k73lpt4fot1fmm9r3.apps.googleusercontent.com',
        scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
        callback: function callback(response) {
          console.log("googleTokenCallback :", response);
          if (response) {
            console.log("response");
            var accessToken = response.access_token;

            if (accessToken) {
              console.log("location.href  :" + location.href);
              var baseURL = location.href.includes('staging') ? location.protocol + '//staging-napi.' + window.location.host.split('.')[1] + '.com/' : location.protocol + '//napi.' + window.location.host.split('.')[1] + '.com/';
              var params = {
                accessToken: accessToken

                // expiresIn: response.expiresIn,
                // platform: platformNum
              };
              // referrer
              var r = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.parse(window.location.search, { ignoreQueryPrefix: true }).r;
              console.log("response param r: " + r);
              if (r) {
                params.r = r;
              }
              __WEBPACK_IMPORTED_MODULE_1__utils_auth_js__["a" /* default */].setCookie('userEmail', 'facebook', 30);
              window.location.href = baseURL + 'webapi/page/googlelogin/GoogleDialogLogin?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(params);
              console.log("response url :" + window.location.href);
              // window.location.href = 'www.google.com/' + qs.stringify(params)
            }
          }
        }
      });
    }

    window.googleClient.requestAccessToken();
  },
  yahooLogin: function yahooLogin() {
    var baseURL = location.href.includes('staging') ? location.protocol + '//staging-napi.' + window.location.host.split('.')[1] + '.com/' : location.protocol + '//napi.' + window.location.host.split('.')[1] + '.com/';
    var client_id = void 0;
    if (location.href.indexOf('staging') !== -1) {
      client_id = 'dj0yJmk9TnZCeXBlT21rNkszJmQ9WVdrOVlrVnZOV05aTVVzbWNHbzlNQT09JnM9Y29uc3VtZXJzZWNyZXQmc3Y9MCZ4PWZh'; //测试
    } else {
      client_id = 'dj0yJmk9TVNkemFCeFFwYWFrJmQ9WVdrOVZWazFTa0ZCVDBNbWNHbzlNQT09JnM9Y29uc3VtZXJzZWNyZXQmc3Y9MCZ4PTMy'; //线上
    }

    __WEBPACK_IMPORTED_MODULE_1__utils_auth_js__["a" /* default */].setCookie('userEmail', 'facebook', 30);
    window.location.href = "https://api.login.yahoo.com/oauth2/request_auth?" + "client_id=" + client_id + "&response_type=code" + "&redirect_uri=" + encodeURIComponent(baseURL + "WebAPI/page/yahoologin/YahooLogin");
  }
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  platform: '',
  userLocationCode: 0,
  isLogin: false,
  accountConfirmed: false,
  usernameConfirmed: false
});

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request__ = __webpack_require__(228);


/* harmony default export */ __webpack_exports__["a"] = ({
  // 登录注册相关
  login: function login(data) {
    return __WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */].oldService({
      method: 'post',
      url: 'WebAPI/Login/WebLogin',
      data: data
    });
  },
  getUserLocation: function getUserLocation() {
    return __WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */].service({
      method: 'post',
      url: 'webapi/common/user/checkIp'
    });
  },
  forgetPassword: function forgetPassword(data) {
    return __WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */].oldService({
      method: 'post',
      url: 'WebAPI/Passport/ToForgetPassword',
      data: data
    });
  },
  resetPassword: function resetPassword(data) {
    return __WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */].oldService({
      method: 'post',
      url: 'WebAPI/Passport/ResetPassword',
      data: data
    });
  },
  singUp: function singUp(data) {
    return __WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */].oldService({
      method: 'post',
      url: 'WebAPI/Passport/WebRegister',
      data: data
    });
  },
  getLoginUserInfo: function getLoginUserInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */].oldService({
      method: 'get',
      url: 'WebAPI/Passport/GetLoginUserInfo',
      params: data
    });
  },
  bindLzRoleName: function bindLzRoleName(data) {
    return __WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */].oldService({
      method: 'post',
      url: 'WebAPI/Passport/BindLzRoleName',
      data: data
    });
  },
  bindAvatar: function bindAvatar(data) {
    return __WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */].oldService({
      method: 'post',
      url: 'WebAPI/Passport/BindAvatar',
      data: data
    });
  },
  getFacebookLoginEntranceURL: function getFacebookLoginEntranceURL(data) {
    return __WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */].oldService({
      method: 'get',
      url: 'WebAPI/page/FacebookLogin/GetFacebookLoginEntranceURL',
      params: data
    });
  },

  // 验证码相关
  showCaptchaWhenRegister: function showCaptchaWhenRegister(data) {
    return __WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */].oldService({
      method: 'post',
      url: 'WebAPI/page/Captcha/ShowCaptchaWhenRegister',
      data: data
    });
  },
  getCaptchaToken: function getCaptchaToken(data) {
    return __WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */].oldService({
      method: 'get',
      url: 'WebAPI/page/Captcha/GetTokenH5',
      params: data
    });
  },
  showCaptchaWhenLogin: function showCaptchaWhenLogin(data) {
    return __WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */].oldService({
      method: 'post',
      url: 'WebAPI/page/Captcha/ShowCaptchaWhenLogin',
      data: data
    });
  },
  getToken: function getToken(data) {
    return __WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */].oldService({
      method: 'get',
      url: 'WebAPI/Passport/GetCryptoToken',
      param: data
    });
  }
});

/***/ }),

/***/ 474:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 475:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 477:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 478:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 481:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FBDeprecatedModal_vue__ = __webpack_require__(144);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a77e42a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FBDeprecatedModal_vue__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(24);
function injectStyle (context) {
  __webpack_require__(477)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a77e42a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FBDeprecatedModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a77e42a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FBDeprecatedModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a77e42a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FBDeprecatedModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Avatar_vue__ = __webpack_require__(146);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b267ba0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Avatar_vue__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(24);
function injectStyle (context) {
  __webpack_require__(482)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b267ba0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Avatar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b267ba0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Avatar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b267ba0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Avatar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(147);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7539291d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(24);
function injectStyle (context) {
  __webpack_require__(480)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7539291d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7539291d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7539291d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Password_vue__ = __webpack_require__(148);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16c09d31_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Password_vue__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(24);
function injectStyle (context) {
  __webpack_require__(475)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16c09d31"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16c09d31_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Password_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16c09d31_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Password_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__ = __webpack_require__(149);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6762c5e3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(24);
function injectStyle (context) {
  __webpack_require__(478)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6762c5e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6762c5e3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6762c5e3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__(150);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b07fb80_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(24);
function injectStyle (context) {
  __webpack_require__(481)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b07fb80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b07fb80_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b07fb80_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Username_vue__ = __webpack_require__(151);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7878e84_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Username_vue__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(24);
function injectStyle (context) {
  __webpack_require__(483)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c7878e84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Username_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7878e84_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Username_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7878e84_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Username_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.topTitles)?_c('div',{staticClass:"web_top_title"},[_c('div',{staticClass:"top_title_main",domProps:{"textContent":_vm._s(_vm.titles)}}),_vm._v(" "),_c('div',{staticClass:"top_title_sub",domProps:{"textContent":_vm._s(_vm.titlesCon)}})]):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floating_container"},[_c('titles'),_vm._v(" "),_c('Alert',{ref:"tips"}),_vm._v(" "),_c('div',{staticClass:"container_content"},[_c('banner'),_vm._v(" "),_c('div',{staticClass:"content_wrapper"},[_c('div',{staticClass:"content_container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content_top"},[_c('div',{staticClass:"content_title"},[_vm._v("Reset Password")]),_vm._v(" "),_c('div',{staticClass:"switch"},[_c('router-link',{attrs:{"to":"login#email"}},[_c('strong',[_vm._v("Cancel >")])])],1)]),_vm._v(" "),_c('div',{staticClass:"email_login"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],ref:"email",staticClass:"form_field",attrs:{"type":"text","placeholder":"Please enter your email","autofocus":"autofocus"},domProps:{"value":(_vm.email)},on:{"blur":function($event){_vm.emailCheck()},"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"email_button hover_effect",on:{"click":function($event){_vm.reset()}}},[_vm._v("Reset")])])])]),_vm._v(" "),_c('div',{staticClass:"alt_option"},[_vm._v("\n        Don't have an account?\n        "),_c('router-link',{attrs:{"to":"signup"}},[_c('strong',[_vm._v("Sign up")])])],1)])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.bannerPic ? 'bg_image' : 'bg_image_web']},[_c('img',{attrs:{"src":__webpack_require__(490)}})])}
var staticRenderFns = []


/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.popShow)?_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-close",on:{"click":function($event){_vm.hide()}}},[_vm._v("×")]),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('p',[_vm._v("\n              Facebook Login is no longer working. Please use our Email Login\n              by resetting your password by clicking\n              "),_c('router-link',{attrs:{"to":"password"}},[_vm._v("this link")]),_vm._v(".\n            ")],1),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_c('router-link',{staticClass:"email_button hover_effect",staticStyle:{"width":"52%"},attrs:{"to":"password","tag":"button"}},[_vm._v("Reset password")])],1),_vm._v(" "),_c('p',[_vm._v("\n              Enter the email associated with your Facebook account at time of\n              registration. You will get an email with a link to create a\n              password to log in. YOU ONLY NEED TO DO THIS ONCE. Afterwards,\n              you can log in using our Email Login using this link.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              If you are having trouble resetting your password or\n              experiencing any other issues, please contact\n              "),_c('a',{attrs:{"href":"mailto:support@pokerallday.com"}},[_vm._v("support@pokerallday.com")]),_vm._v("\n              with your username (name in the game) and we will help you get\n              back in.\n            ")])])])])])])]):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floating_container"},[_c('titles'),_vm._v(" "),_c('Alert',{ref:"tips"}),_vm._v(" "),_c('div',{staticClass:"container_content"},[_c('banner'),_vm._v(" "),_c('div',{staticClass:"content_wrapper"},[_c('div',{staticClass:"content_container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content_top"},[_c('div',{staticClass:"content_title"},[_vm._v("Reset Password")]),_vm._v(" "),_c('div',{staticClass:"switch"},[_c('router-link',{attrs:{"to":"login#email"}},[_c('strong',[_vm._v("Cancel >")])])],1)]),_vm._v(" "),_c('div',{staticClass:"email_login"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password1),expression:"password1"}],staticClass:"form_field",attrs:{"type":"password","placeholder":"New password"},domProps:{"value":(_vm.password1)},on:{"blur":function($event){_vm.password1Check()},"input":function($event){if($event.target.composing){ return; }_vm.password1=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password2),expression:"password2"}],staticClass:"form_field",attrs:{"type":"password","placeholder":"Confirm password"},domProps:{"value":(_vm.password2)},on:{"blur":function($event){_vm.password2Check()},"input":function($event){if($event.target.composing){ return; }_vm.password2=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"email_button hover_effect",on:{"click":function($event){_vm.reset()}}},[_vm._v("Reset")])])])]),_vm._v(" "),_c('div',{staticClass:"alt_option"},[_vm._v("Don't have an account?\n        "),_c('router-link',{attrs:{"to":"signup"}},[_c('strong',[_vm._v("Sign up")])])],1)])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []


/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.popShow)?_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"top_notification"},[_vm._v(_vm._s(_vm.popText))])]):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FBDeprecatedModal',{ref:"fbDeprecatedModal"}),_vm._v(" "),_c('div',{staticClass:"floating_container"},[_c('titles',{attrs:{"currentPage":_vm.currentLogin}}),_vm._v(" "),_c('Alert',{ref:"tips"}),_vm._v(" "),_c('div',{staticClass:"container_content"},[_c('banner'),_vm._v(" "),_c('div',{staticClass:"content_wrapper"},[_c('div',{staticClass:"content_container_outline login"},[_c('div',{staticClass:"content_container login"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content_top"},[_c('div',{staticClass:"content_title"},[_vm._v("Log in & Play")]),_vm._v(" "),(_vm.stateBtn)?_c('div',{staticClass:"switch",on:{"click":function($event){_vm.switchFacebook()}}},[_c('router-link',{attrs:{"to":"login#facebook"}},[_c('strong',[_vm._v("Other log in options >")])])],1):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.facebook),expression:"facebook"}],staticClass:"google_login"},[_c('div',{staticClass:"google_button",on:{"click":function($event){_vm.handleGoogleLogin()}}},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"google_txt"},[_vm._v("Log in with Google")])]),_vm._v(" "),_c('div',{staticClass:"login_separator"}),_vm._v(" "),_c('div',{staticClass:"yahoo_button",on:{"click":function($event){_vm.handleYahooLogin()}}},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"google_txt"},[_vm._v("Log in with Yahoo")])]),_vm._v(" "),_c('div',{staticClass:"login_separator"}),_vm._v(" "),_c('div',{staticClass:"facebook_button hover_effect",on:{"click":function($event){_vm.handleFacebookLogin()}}},[_vm._m(2),_vm._v(" "),_c('span',{staticClass:"facebook_text"},[_vm._v("Log in with Facebook")])]),_vm._v(" "),_c('div',{staticClass:"login_separator"},[_vm._v("or")]),_vm._v(" "),_c('div',{staticClass:"with_email",on:{"click":function($event){_vm.switchEmail()}}},[_c('router-link',{attrs:{"to":"login#email"}},[_vm._v("Log in with email")])],1)]),_vm._v(" "),(_vm.emailLogin)?_c('div',{staticClass:"email_login"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],ref:"email",staticClass:"form_field",attrs:{"type":"text","maxlength":"45","placeholder":"Email","autofocus":""},domProps:{"value":(_vm.email)},on:{"blur":function($event){_vm.emailCheck()},"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],ref:"password",staticClass:"form_field",attrs:{"type":"password","maxlength":"16","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"blur":function($event){_vm.passwordCheck()},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"email_button hover_effect",on:{"click":function($event){_vm.handleEmailLogin()}}},[_vm._v("Log in")]),_vm._v(" "),_c('div',{staticClass:"forgot_password"},[_c('router-link',{attrs:{"to":"password"}},[_vm._v("Forgot password")])],1)]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"alt_option"},[_vm._v("Don't have an account? \r\n          "),_c('router-link',{attrs:{"to":"signup"}},[_c('strong',[_vm._v("Create an account")])])],1)])],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"google_logo"},[_c('img',{attrs:{"src":__webpack_require__(203)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"yahoo_logo"},[_c('img',{attrs:{"src":__webpack_require__(202)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"facebook_logo"},[_c('img',{attrs:{"src":__webpack_require__(489)}})])}]


/***/ }),

/***/ 506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floating_container"},[_c('titles',{attrs:{"currentPage":_vm.currentLogin}}),_vm._v(" "),_c('Alert',{ref:"tips"}),_vm._v(" "),_c('div',{staticClass:"container_content"},[_c('banner'),_vm._v(" "),_c('div',{staticClass:"content_wrapper"},[_c('div',{staticClass:"content_container_outline login"},[_c('div',{staticClass:"content_container login"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content_top"},[_c('div',{staticClass:"content_title"},[_vm._v("Create account")]),_vm._v(" "),(_vm.stateBtn)?_c('div',{staticClass:"switch",on:{"click":function($event){_vm.switchFacebook()}}},[_c('router-link',{attrs:{"to":"signup#facebook"}},[_c('strong',[_vm._v("Other log in options >")])])],1):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.facebook),expression:"facebook"}],staticClass:"google_login"},[(true)?_c('div',{staticClass:"google_button",on:{"click":function($event){_vm.handleGoogleLogin()}}},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"google_txt"},[_vm._v("Log in with Google")])]):_vm._e(),_vm._v(" "),(true)?_c('div',{staticClass:"login_separator"}):_vm._e(),_vm._v(" "),(true)?_c('div',{staticClass:"yahoo_button",on:{"click":function($event){_vm.handleYahooLogin()}}},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"google_txt"},[_vm._v("Log in with Yahoo")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"login_separator"},[_vm._v("or")]),_vm._v(" "),_c('div',{staticClass:"with_email",on:{"click":function($event){_vm.switchEmail()}}},[_c('router-link',{attrs:{"to":"signup#email"}},[_vm._v("Sign up with email")])],1)]),_vm._v(" "),(_vm.emailLogin)?_c('div',{staticClass:"email_login"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],ref:"email",staticClass:"form_field",attrs:{"type":"text","maxlength":"45","placeholder":"Email","autofocus":""},domProps:{"value":(_vm.email)},on:{"blur":function($event){_vm.emailCheck()},"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],ref:"password",staticClass:"form_field",attrs:{"type":"password","maxlength":"16","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"blur":function($event){_vm.passwordCheck()},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"email_button hover_effect",on:{"click":_vm.handleEmailSignUp}},[_vm._v("Sign up")]),_vm._v(" "),(_vm.isFromEU)?_c('div',{staticClass:"agreement"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],attrs:{"type":"checkbox","id":"check-box"},domProps:{"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,null)>-1:(_vm.checked)},on:{"change":function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"id":"check-box-label","for":"check-box"}},[_vm._v("I would like to receive email updates, notifications and\n                  special promotional\n                  offers from PokerAllDay.")])]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"alt_option"},[_vm._v("Already have an account?\n          "),_c('router-link',{attrs:{"to":"login"}},[_c('strong',[_vm._v("Log in")])])],1)])],1),_vm._v(" "),(_vm.emailLogin && !_vm.isFromEU )?_c('div',{staticClass:"protocol"},[_vm._v("By entering my email here, I have read and agree to the "),_c('a',{attrs:{"target":"_blank","href":"https://www.pokerallday.com/privacy"}},[_vm._v("Privacy Policy")]),_vm._v("\n    and agree to receive email updates, notifications, and special promotional offers from PokerAllDay.\n  ")]):_vm._e(),_vm._v(" "),(_vm.emailLogin && _vm.isFromEU )?_c('div',{staticClass:"protocol"},[_vm._v("By entering my email here, I have read and agree to the\n    "),_c('a',{attrs:{"target":"_blank","href":"https://www.pokerallday.com/terms"}},[_vm._v("Terms and Conditions ")]),_vm._v(" and "),_c('a',{attrs:{"target":"_blank","href":"https://www.pokerallday.com/privacy"}},[_vm._v("Privacy Policy.")])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"google_logo"},[_c('img',{attrs:{"src":__webpack_require__(203)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"yahoo_logo"},[_c('img',{attrs:{"src":__webpack_require__(202)}})])}]


/***/ }),

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floating_container"},[_c('titles'),_vm._v(" "),_c('Alert',{ref:"tips"}),_vm._v(" "),_c('div',{staticClass:"container_content"},[_c('banner'),_vm._v(" "),_c('div',{staticClass:"content_wrapper"},[_c('div',{staticClass:"avatar_top"},[_c('div',{staticClass:"avatar_content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"avatars"},[_c('ul',_vm._l((_vm.selectActive),function(item,index){return _c('li',{staticClass:"background_avatar_wrapper",class:{'selected_avatar': item.active},on:{"click":function($event){_vm.selectAvatar(item, index)}}},[_c('img',{attrs:{"src":item.src}})])})),_vm._v(" "),_c('div',{staticClass:"submit_button hover_effect",on:{"click":function($event){_vm.playNow()}}},[_vm._v("Play Now!")])])])])])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content_top"},[_c('div',{staticClass:"content_title"},[_vm._v("Choose an avatar")])])}]


/***/ }),

/***/ 508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floating_container"},[_c('titles'),_vm._v(" "),_c('Alert',{ref:"tips"}),_vm._v(" "),_c('div',{staticClass:"container_content"},[_c('banner'),_vm._v(" "),_c('div',{staticClass:"content_wrapper"},[_c('div',{staticClass:"content_container"},[_c('div',{staticClass:"content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"email_login"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],ref:"name",staticClass:"form_field",attrs:{"type":"text","placeholder":"Enter username","maxlength":"20","autofocus":""},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"email_button hover_effect",on:{"click":function($event){_vm.next()}}},[_vm._v("Next")])])])])])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content_top"},[_c('div',{staticClass:"content_title"},[_vm._v("Choose a username")])])}]


/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_account_js__ = __webpack_require__(31);


/* harmony default export */ __webpack_exports__["a"] = ({
  getCookie: function getCookie(key) {
    var reg = new RegExp('\\b' + key + '=([^;]+)(; |$)');
    var val = document.cookie.match(reg);
    return val ? decodeURIComponent(val[1]) : '';
  },
  setCookie: function setCookie(key, value, time) {
    var data = new Date(new Date().getTime() + time * 1000 * 60 * 60 * 24);
    document.cookie = key + '=' + encodeURIComponent(value) + ';expires=' + data.toGMTString();
  },
  delCookie: function delCookie(key) {
    this.setCookie(key, '', -1);
  },
  rsa: function rsa(password) {
    var _this = this;

    window.setMaxDigits(131);
    var publicKey = this.getCookie('cryptowpt');
    if (!(publicKey && publicKey.split(':').length === 3)) {
      __WEBPACK_IMPORTED_MODULE_0__api_account_js__["a" /* default */].getToken({
        version: Math.random()
      }).then(function (res) {
        if (res.data.State) {
          publicKey = _this.getCookie('cryptowpt');
        }
      });
    }
    var key = new window.RSAKeyPair(publicKey.split(':')[2], '', publicKey.split(':')[1], 1024);
    return window.encryptedString(key, window.base64encode(window.strUnicode2Ansi(password)), window.RSAAPP.PKCS1Padding);
  }
});

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__ = __webpack_require__(142);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7315372c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(24);
function injectStyle (context) {
  __webpack_require__(479)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7315372c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7315372c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7315372c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

/* harmony default export */ __webpack_exports__["a"] = ({
  email: function email(_email, message) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (_email.includes('')) {
      _email = _email.replace(/[ ]/g, '');
    }
    if (!_email) {
      message('Please enter your email account');
      return false;
    } else if (_email.length < 6) {
      message('Your email account is too short, please input the correct email');
      return false;
    } else if (!re.test(_email)) {
      message('Please input a correct email address');
      return false;
    } else {
      return true;
    }
  },
  password: function password(_password, message) {
    var str = ",'\"“”‘ ;";
    if (!_password) {
      message("Please input 6-16 characters which can be letters, numbers, symbols excluding ,;'");
      return false;
    } else if (_password.length > 16 || _password.length < 6) {
      message("Your password is too short. Please input 6-16 characters which can be letters, numbers, symbols excluding ,;'");
      return false;
    } else if (this._hasFullShape(_password)) {
      message("Please input 6-16 characters which can be letters, numbers, symbols excluding ,;'");
      return false;
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_password), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var i = _step.value;

        if (str.includes(i)) {
          message("Please input 6-16 characters which can be letters, numbers, symbols excluding ,;'");
          return false;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return true;
  },
  username: function username(_username, message) {
    if (!_username) {
      message('Please input your username');
      return false;
    } else if (_username.includes(' ')) {
      message('Sorry, your username cannot contain space');
      return false;
    } else if (_username.replace(/[^\x00-\xff]/g, 'xx').length < 4) {
      message('Your username is too short, please input 4-20 characters as your username');
      return false;
    } else {
      return true;
    }
  },
  _hasFullShape: function _hasFullShape(password) {
    if (!password) {
      return true;
    }
    var pattern = /[^\x00-\xff]/g;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(password), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var i = _step2.value;

        if (pattern.test(i)) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return false;
  },
  getQuery: function getQuery() {
    var paramsArr = window.location.hash.substr(1).split('&');
    var params = {};
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(paramsArr), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var i = _step3.value;

        var aParamArr = i.split('=');
        if (aParamArr[0].length) {
          params[aParamArr[0]] = decodeURIComponent(aParamArr[1]);
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return params;
  }
});

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);

/* harmony default export */ __webpack_exports__["a"] = ({
  statisticsLogin: function statisticsLogin(platform, names, type) {
    if (platform === 'LegendHill') {
      fbq('track', 'cumulus_' + names);
      ga('send', 'event', 'cumulus_login', type);
    }
    if (platform === 'Facebook') {
      fbq('track', names);
      ga('send', 'event', 'login', type);
    }
  },
  facebookLogin: function facebookLogin() {
    fbq('track', 'login_fb_click');
    ga('send', 'event', 'login', 'login_fb_click');
  },
  loginSucceed: function loginSucceed(platform) {
    if (platform === 'LegendHill') {
      fbq('track', 'cumulus_login_email_success');
      ga('send', 'event', 'cumulus_login', 'email', 'success');
    }
    if (platform === 'Facebook') {
      fbq('track', 'login_email_success');
      ga('send', 'event', 'login', 'email', 'success');
    }
  },
  loginFailed: function loginFailed(platform, reason) {
    if (platform === 'LegendHill') {
      fbq('track', 'cumulus_login_email_fail');
      ga('send', 'event', 'cumulus_login', 'fail', reason);
    }
    if (platform === 'Facebook') {
      fbq('track', 'login_email_fail', {
        error: reason
      });
      ga('send', 'event', 'login', 'fail', reason);
    }
  },
  statisticsSign: function statisticsSign(platform, names, type) {
    if (platform === 'LegendHill') {
      fbq('track', 'cumulus_' + names);
      ga('send', 'event', 'cumulus_signup', type);
    }
    if (platform === 'Facebook') {
      fbq('track', names);
      ga('send', 'event', 'signup', type);
    }
  },
  facebookSignUp: function facebookSignUp() {
    fbq('track', 'signup_fb_click');
    ga('send', 'event', 'signup', 'signup_fb_click');
  },
  signSucceed: function signSucceed(platform) {
    if (platform === 'LegendHill') {
      fbq('track', 'cumulus_signup_email_success');
      ga('send', 'event', 'cumulus_signup', 'email', 'success');
      ga('send', 'event', 'cumulus_Signup', 'Register', 'E-mail');
    }
    if (platform === 'Facebook') {
      fbq('track', 'signup_email_success');
      ga('send', 'event', 'signup', 'email', 'success');
      ga('send', 'event', 'Signup', 'Register', 'E-mail');
    }

    // window.google_trackConversion({
    //   google_conversion_id: 809269598,
    //   google_conversion_label: conversionLabels.register,
    //   google_remarketing_only: false

    // })

    yAnalytics('registration');

    bingTrackEvent('login', 'authorization', 'web', 1);
  },
  signFailed: function signFailed(reason) {
    fbq('track', 'signup_email_fail', {
      error: reason
    });
    ga('send', 'event', 'signup', 'email', 'fail', reason);
  },
  avatarStatistics: function avatarStatistics(platform, gender, avatarClick, sex) {
    var sexMapping = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a([[1, 'f'], [2, 'm']]);
    if (platform === 'LegnedHill') {
      fbq('track', 'cumulus_' + gender);
      ga('send', 'event', 'cumulus_signup', avatarClick);
    }
    if (platform === 'Facebook') {
      fbq('track', 'fb_' + gender);
      ga('send', 'event', 'fb_signup', avatarClick);
    }
    if (platform === 'Web') {
      fbq('track', gender);
      ga('send', 'event', 'signup', avatarClick);
      ga('send', 'event', 'Signup', 'Avatar', sexMapping.get(sex));
    }
    // window.google_trackConversion({
    //   google_conversion_id: 809269598,
    //   google_conversion_label: conversionLabels.as,
    //   google_remarketing_only: false
    // })
  },
  selectUsernameSucceed: function selectUsernameSucceed(platform) {
    if (platform === 'Web') {
      fbq('track', 'create_username_success');
      ga('send', 'event', 'signup', 'username_create');
    }
    if (platform === 'Facebook' || platform === 'LegendHill') {
      fbq('track', 'fb_create_username_success');
      ga('send', 'event', 'fb_signup', 'username_create');
    }
    ga('send', 'event', 'Signup', 'Entered', 'Username');
    // window.google_trackConversion({
    //   google_conversion_id: 809269598,
    //   google_conversion_label: conversionLabels.ue,
    //   google_remarketing_only: false
    // })
  },
  selectUsernameFailed: function selectUsernameFailed(platform, reason) {
    if (platform === 'Web') {
      fbq('track', 'create_username_fail', {
        error: reason
      });
      ga('send', 'event', 'signup', 'username_create', 'fail', reason);
    }
    if (platform === 'Facebook' || platform === 'LegendHill') {

      fbq('track', 'fb_create_username_fail', {
        error: reason
      }); // facebook像素统计facebook创建username失败及原因
      ga('send', 'event', 'fb_signup', 'username_create', 'fail', reason);
    }
  }
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Login__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Signup__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Username__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Avatar__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Password__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Reset__ = __webpack_require__(495);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({

  routes: [{
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Login__["a" /* default */]
  }, {
    path: '/login%23*', // a hack for matching escaped /login#*
    component: __WEBPACK_IMPORTED_MODULE_2__views_Login__["a" /* default */]
  }, {
    path: '/signup',
    name: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Signup__["a" /* default */]
  }, {
    path: '/username',
    name: 'Username',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Username__["a" /* default */]
  }, {
    path: '/avatar',
    name: 'Avatar',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Avatar__["a" /* default */]
  }, {
    path: '/password',
    name: 'Password',
    component: __WEBPACK_IMPORTED_MODULE_6__views_Password__["a" /* default */]
  }, {
    path: '/reset',
    name: 'Reset',
    component: __WEBPACK_IMPORTED_MODULE_7__views_Reset__["a" /* default */]
  }]
}));

/***/ })

},[227]);


// WEBPACK FOOTER //
// static/js/app.200d61b797d9faa7a4bb.js